export { default } from './BlogDataFeitoPor';
